module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showgrid),
      expression: "showgrid"
    }]
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "ng-show": "$ctrl.isNewAvaiable()"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.formEditavel) ? _c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "tooltip": "Adiciona um público alvo",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showgrid = !_vm.showgrid
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo curso")]) : _vm._e()])]), _vm._v(" "), (_vm.formEditavel) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {}, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [(_vm.formEditavel) ? _c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.edita(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
          directives: [{
            name: "confirm",
            rawName: "v-confirm",
            value: ({
              ok: function (retorno) { return _vm.exclui(row); },
              cancel: _vm.doNothing,
              message: 'Deseja <b>APAGAR</b> o curso ' + row.item.ds_titulo + ' ?'
            }),
            expression: "{ok: retorno => exclui(row), cancel: doNothing,\n                         message: 'Deseja <b>APAGAR</b> o curso ' + row.item.ds_titulo + ' ?'}"
          }],
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1)], 1)])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('título do curso')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "título do curso"
    }
  }, [_vm._v("Título do curso:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.ds_titulo),
      expression: "curso.ds_titulo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "título do curso",
      "type": "text"
    },
    domProps: {
      "value": (_vm.curso.ds_titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "ds_titulo", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('título do curso')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('título do curso')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('quantidade de educadores')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "quantidade de educadores"
    }
  }, [_vm._v(" Quantidade de educadores: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.nr_qt_educadores),
      expression: "curso.nr_qt_educadores"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:2147483647'),
      expression: "'required|min_value:1|max_value:2147483647'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "quantidade de educadores",
      "id": "quantidade de educadores",
      "type": "number"
    },
    domProps: {
      "value": (_vm.curso.nr_qt_educadores)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "nr_qt_educadores", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('quantidade de educadores')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade de educadores')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('carga horaria')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "carga horaria"
    }
  }, [_vm._v("Carga horária total por turma:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    attrs: {
      "name": "career.workload.null"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.nr_carga_horaria),
      expression: "curso.nr_carga_horaria"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:2147483647'),
      expression: "'required|min_value:1|max_value:2147483647'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "carga horaria",
      "id": "carga horaria",
      "type": "number"
    },
    domProps: {
      "value": (_vm.curso.nr_carga_horaria)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "nr_carga_horaria", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Horas")])]), _vm._v(" "), (_vm.errors.first('carga horaria')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('carga horaria')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('quantidade de turmas')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "quantidade de turmas"
    }
  }, [_vm._v("Quantidade de turmas:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.nr_qt_turmas),
      expression: "curso.nr_qt_turmas"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:2147483647'),
      expression: "'required|min_value:1|max_value:2147483647'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "quantidade de turmas",
      "id": "quantidade de turmas",
      "type": "number"
    },
    domProps: {
      "value": (_vm.curso.nr_qt_turmas)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "nr_qt_turmas", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('quantidade de turmas')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade de turmas')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('quantidade de alunos por turma')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "quantidade de alunos por turma"
    }
  }, [_vm._v("Quantidade de alunos por turma:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.nr_qt_alunos_turma),
      expression: "curso.nr_qt_alunos_turma"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:2147483647'),
      expression: "'required|min_value:1|max_value:2147483647'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "quantidade de alunos por turma",
      "id": "quantidade de alunos por turma",
      "type": "number"
    },
    domProps: {
      "value": (_vm.curso.nr_qt_alunos_turma)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "nr_qt_alunos_turma", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('quantidade de alunos por turma')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade de alunos por turma')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('público-alvo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "título do curso"
    }
  }, [_vm._v("Público-alvo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.ds_publico_alvo),
      expression: "curso.ds_publico_alvo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "público-alvo",
      "id": "público-alvo",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.curso.ds_publico_alvo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "ds_publico_alvo", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('público-alvo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('público-alvo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('conteúdo programático mínimo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "conteúdo programático mínimo"
    }
  }, [_vm._v("Conteúdo programático mínimo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.ds_conteudo),
      expression: "curso.ds_conteudo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "conteúdo programático mínimo",
      "id": "conteúdo programático mínimo",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.curso.ds_conteudo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "ds_conteudo", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('conteúdo programático mínimo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('conteúdo programático mínimo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('perfil dos profissionais a serem contratados')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "perfil dos profissionais a serem contratados"
    }
  }, [_vm._v("Perfil dos profissionais a serem contratados:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.ds_perfil_profissional),
      expression: "curso.ds_perfil_profissional"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "perfil dos profissionais a serem contratados",
      "id": "perfil dos profissionais a serem contratados",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.curso.ds_perfil_profissional)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "ds_perfil_profissional", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('perfil dos profissionais a serem contratados')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('perfil dos profissionais a serem contratados')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('especificação dos serviços')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "especificação dos serviços"
    }
  }, [_vm._v("Especificação dos serviços:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.ds_especificacao_servico),
      expression: "curso.ds_especificacao_servico"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "especificação dos serviços",
      "id": "especificação dos serviços",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.curso.ds_especificacao_servico)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.curso, "ds_especificacao_servico", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('especificação dos serviços')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('especificação dos serviços')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('outroCurso')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "outroCurso"
    }
  }, [_vm._v("Os alunos deste curso estarão inscritos em outros cursos deste projeto?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curso.outroCurso),
      expression: "curso.outroCurso"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "outroCurso"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.curso, "outroCurso", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Sim")])])]), _vm._v(" "), (_vm.errors.first('outroCurso')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('outroCurso')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-4"
  }, [_c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5deab2a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/cursos.vue
// module id = 1975
// module chunks = 1